export default [{
  path: '/category',
  name: 'category',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/category/index')
}]
